// extracted by mini-css-extract-plugin
module.exports = {"base":"LoginBox_base__FEzxv","error":"LoginBox_error___WQp3"};